define('AdvancedSearch.View',
  [
    'SCView',
    'jQuery',
    'underscore',
    'advanced_search_view.tpl'
  ], function (
    SCViewComponent,
    jQuery,
    _,
    Template
  ) {

    'use strict';

    var SCView = SCViewComponent.SCView;

    function AdvancedSearchView(options) {
      SCView.call(this);

      this.options = options || {};
      this.template = Template;

      this.initialize = function initialize(opt) {
        this.advancedSearchConfig = opt.advancedSearchConfig;
        this.model = opt.model;
        var self = this;
        this.model.fetch({
          data: {
            fieldList: JSON.stringify(_.pluck(this.advancedSearchConfig.fields, 'customListRecordId'))
          }
        }).done(function (result) {
          if (result) {
            _.each(self.advancedSearchConfig.fields, function (field) {
              var values = _.find(result, function (elem) {
                return Object.keys(elem)[0] === field.customListRecordId;
              });
              field.values = values && values[field.customListRecordId] || [];
              return true;
            });
            self.fieldsPerRow = _.groupBy(self.advancedSearchConfig.fields, 'section');
            if(!_.isEmpty(self.fieldsPerRow)) {
              self.fieldsPerRow = _.sortBy(self.fieldsPerRow, function (elem) {
                return elem[0] && elem[0].sectionOrder;
              });
            }
            self.render();
          }
        });
      };

      this.initialize(options);
    }

    AdvancedSearchView.prototype = Object.create(SCView.prototype);

    AdvancedSearchView.prototype.constructor = AdvancedSearchView;

    AdvancedSearchView.prototype.getEvents = function () {
      return {
        'submit form': 'plpRedirection'
      };
    };

    AdvancedSearchView.prototype.plpRedirection = function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var self = this;
      var formData = jQuery('.advanced-search-form').serializeArray();
      var params = formData.map(function (param) {
        if (param && param.value !== 'default') {
          return param.name + '=' + self.formatForUrl(param.value);
        }
      }).filter(function (elem) {
        // eslint-disable-next-line
        return elem !== undefined;
      }).join('&');
      jQuery('#advaced-search-collapse').removeClass('in');
      if (params) {
        // Backbone.history.navigate('search?order=relevance:desc&' , { trigger: true });
        window.location.href = Backbone.history.location.origin + '/search?order=relevance:desc&' + params;
      }
    };

    AdvancedSearchView.prototype.formatForUrl = function (text) {
      var textToFormat = text;
      var replaceableCharacters = [
        { character: '-', encodedValue: '~' },
        { character: '/', encodedValue: '-SLASH-' },
        { character: '&(?!amp;)', encodedValue: '-AND-' },
        { character: ',', encodedValue: '%2C' },
        { character: "'", encodedValue: '%27' },
        { character: ' ', encodedValue: '-' }
      ];

      _.each(replaceableCharacters, function (replaceableCharacter) {
        var expression = new RegExp(replaceableCharacter.character, 'g');
        textToFormat = textToFormat.replace(expression, replaceableCharacter.encodedValue);
      });

      return textToFormat;
    };

    AdvancedSearchView.prototype.getContext = function () {
      return {
        fieldGroup: this.fieldsPerRow
      };
    };
    return AdvancedSearchView;
  });
